import React from 'react';
import { Navigate } from 'react-router-dom';
import withPermission from '../../utils/withPermission';
import permissionTypes from '../../components/atoms/permissionsGate/permissionTypes';

import ListTableTemplate from '../../components/templates/listTableTemplate/listTableTemplate';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import AdminFormTemplate from '../../components/templates/adminFormTemplate/adminFormTemplate';

import viewAdmin from '../../config/viewAdmin';
import viewAdminUsers from '../../config/viewAdminUsers';
import viewAdminUserForm from '../../config/viewAdminUserForm';
import viewLiveDeployments from '../../config/viewLiveDeployments';
import viewLiveSettings from '../../config/viewLiveSettings';
import viewLiveSettingsForm from '../../config/viewLiveSettingsForm';
import viewAdminOrganizationAgreements from '../../config/viewAdminOrganizationAgreements';
import viewBillingTransactions from '../../config/viewBillingTransactions';
import viewOriginEdit from '../../config/viewOriginEdit';
import viewOrigins from '../../config/viewOrigins';
import viewNewOrigin from '../../config/viewNewOrigin';
import viewTagManager from '../../config/viewTagManager';
import viewAudit from '../../config/viewAudit';
import viewTagManagerForm from '../../config/viewTagManagerForm';
import viewTagManagerEditForm from '../../config/viewTagManagerEditForm';
import viewLanguages from '../../config/viewLanguages';
import viewDevices from '../../config/viewDevices';
import viewDeviceNew from '../../config/viewDeviceNew';
import viewDeviceEdit from '../../config/viewDeviceEdit';
import viewDeviceTypes from '../../config/viewDeviceTypes';
import viewApicredentialskeyForm from '../../config/viewApiCredentialsKeyForm';
import viewApiCredentialsKey from '../../config/viewApiCredentialsKey';
import viewApiCredentials from '../../config/viewApiCredentials';
import routes, { getRoute } from '../../routes/route';

export const adminRoutes = [
  {
    path: getRoute(routes.ORGANIZATION),
    element: withPermission(
      [permissionTypes.ADMIN_ORGANIZATION],
      <ListTableTemplate configFile={viewAdmin} />
    ),
  },

  {
    path: getRoute(routes.USERS),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ADMIN_USER],
          <ListTableTemplate configFile={viewAdminUsers} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ADMIN_USER],
          <FormTemplate configFile={viewAdminUserForm} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ADMIN_USER],
          <AdminFormTemplate configFile={viewAdminUserForm} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.AGREEMENTS),
    element: withPermission(
      [permissionTypes.ADMIN_ORGANIZATION],
      <ListTableTemplate configFile={viewAdminOrganizationAgreements} />
    ),
  },

  {
    path: getRoute(routes.AGREEMENTS),
    element: withPermission(
      [permissionTypes.ADMIN_ORGANIZATION],
      <ListTableTemplate configFile={viewBillingTransactions} />
    ),
  },

  {
    path: getRoute(routes.LIVE_DEPLOYMENT),
    element: withPermission(
      [permissionTypes.ADMIN_LIVEDEPLOYMENT],
      <ListTableTemplate configFile={viewLiveDeployments} />
    ),
  },

  {
    path: getRoute(routes.LIVE_SETTINGS),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ADMIN_LIVESETTING],
          <ListTableTemplate configFile={viewLiveSettings} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ADMIN_LIVESETTING],
          <FormTemplate configFile={viewLiveSettingsForm} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ADMIN_LIVESETTING],
          <AdminFormTemplate configFile={viewLiveSettingsForm} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.ORIGINS),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ADMIN_ORGANIZATION],
          <ListTableTemplate configFile={viewOrigins} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ADMIN_ORGANIZATION],
          <FormTemplate configFile={viewNewOrigin} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ADMIN_ORGANIZATION],
          <FormTemplate configFile={viewOriginEdit} />
        ),
      },
    ],
  },

  {
    path: getRoute(routes.TAG_MANAGER),
    children: [
      {
        index: true,
        element: withPermission(
          [permissionTypes.ADMIN_TAGMANAGER],
          <ListTableTemplate configFile={viewTagManager} />
        ),
      },
      {
        path: ':id',
        element: withPermission(
          [permissionTypes.ADMIN_TAGMANAGER],
          <FormTemplate configFile={viewTagManagerForm} />
        ),
      },
      {
        path: 'edit/:id',
        element: withPermission(
          [permissionTypes.ADMIN_TAGMANAGER],
          <AdminFormTemplate configFile={viewTagManagerEditForm} />
        ),
      },
    ],
  },
  {
  path: 'languages',
  element: withPermission(
    [permissionTypes.ADMIN],
    <ListTableTemplate configFile={viewLanguages} />
  ),
},
{
  path: 'devices',
  children: [
    {
      index: true,
      element: withPermission(
        [permissionTypes.ADMIN],
        <ListTableTemplate configFile={viewDevices} />
      ),
    },
    {
      path: ':id',
      element: withPermission(
        [permissionTypes.ADMIN],
        <FormTemplate configFile={viewDeviceNew} />
      ),
    },
    {
      path: 'edit/:id',
      element: withPermission(
        [permissionTypes.ADMIN],
        <FormTemplate configFile={viewDeviceEdit} />
      ),
    },
  ],
},
{
  path: 'device-types',
  element: withPermission(
    [permissionTypes.ADMIN],
    <ListTableTemplate configFile={viewDeviceTypes} />
  ),
},
{
  path: 'key',
  children: [
    {
      index: true,
      element: withPermission(
        [permissionTypes.ADMIN],
        <ListTableTemplate configFile={viewApiCredentialsKey} />
      ),
    },
    {
      path: ':id/tokens',
      element: withPermission(
        [permissionTypes.ADMIN],
        <ListTableTemplate configFile={viewApiCredentials} />
      ),
    },
     {
      path: 'edit/:id',
      element: withPermission(
        [permissionTypes.ADMIN],
        <AdminFormTemplate configFile={viewApicredentialskeyForm} />
      ),
    },
    {
      path: ':id',
      element: withPermission(
        [permissionTypes.ADMIN],
        <FormTemplate configFile={viewApicredentialskeyForm} />
      ),
    },
  ],
},
  {
    path: getRoute(routes.AUDIT),
    element: withPermission(
      [permissionTypes.DEBUG],
      <ListTableTemplate configFile={viewAudit} />
    ),
  },

  {
    index: true,
    element: <Navigate to="organization" replace />,
  },
];